<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <b-row class="mb-3">
                    <b-col class="col-12 text-right">
                        <b-button class="btn btn-success" size="sm" @click="pdfExport">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                            <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                            <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                        </svg>
                        {{ $t('globalTrans.print') }}</b-button>
                    </b-col>
                </b-row>
                <iq-card style="border: 1px solid gray">
                    <template v-slot:body>
                        <b-row>
                            <b-col class="col-12">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <img src="/img/logo.8495d15b.png" class="img-fluid mx-auto d-block" style="height:70px;" alt="logo">
                                        <h6 class="text-center text-dark mt-1" style="font-weight:bold">{{ $t('institute_manangement.ministry_welfare')}}</h6>
                                    </b-col>
                                </b-row>
                                <hr>
                            </b-col>
                            <b-col class="col-12">
                                <b-row>
                                    <b-col v-if="status === 2" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <b-form-group
                                            label-cols-sm="12"
                                            label-for="name"
                                        >
                                            <template v-slot:label>
                                            <b>{{ $t('institute_manangement.guardian_name')}} :</b> {{ checkBn ? formData.legal_guardian_bn : formData.legal_guardian }}
                                            </template>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <b-form-group
                                            label-cols-sm="12"
                                            label-for="name"
                                        >
                                            <template v-slot:label>
                                            <b>{{ $t('rehabilitation_management.resident_name')}} :</b> {{ checkBn ? formData.name_bn : formData.name }}
                                            </template>
                                        </b-form-group>
                                    </b-col>
                                    <b-col v-if="status === 1" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <b-form-group
                                              label-cols-sm="12"
                                              label-for="criteria_name"
                                          >
                                              <template v-slot:label>
                                              <b>{{ $t('institute_manangement.mobile_number')}} : </b> {{ formData.contact_no | mobileNumber }}
                                              </template>
                                          </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                         <b-form-group
                                            label-cols-sm="12"
                                            label-for="registration_id"
                                        >
                                            <template v-slot:label>
                                            <b>{{ $t('institute_manangement.registration_id')}} : </b>{{ formData.registration_id }}
                                            </template>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                      <b-form-group
                                              class="row"
                                              label-cols-sm="12"
                                              label-for="organization"
                                          >
                                              <template v-slot:label>
                                              <b>{{ $t('institute_manangement.organization')}} : </b>{{ checkBn ? formData.org_name_bn : formData.org_name }}
                                              </template>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import Logo from '@/assets/images/logo.png'
import common from '@/mixins/common'
import { childServiceBaseUrl } from '../../../../../config/api_config'
import ExportPdf from './export-pdf_details'

export default {
  mixins: [common],
  props: ['id', 'status'],
  data () {
    return {
        logo: Logo,
        imageAsBase64: 'd',
        formData: {}
    }
  },
  computed: {
    ...mapGetters({
      childCommonObj: 'ChildService/commonObj'
    }),
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getIdCard()
      this.formData = tmp
      this.formData.print_status = this.status
    }
    this.generateBase64()
  },
  methods: {
    generateBase64 () {
      let canvas = document.createElement('CANVAS')
      const img = document.createElement('img')
      img.src = '/img/logo.8495d15b.png'
      img.onload = () => {
        canvas.height = img.height
        canvas.width = img.width
        this.imageAsBase64 = canvas.toDataURL('image/png')
        canvas = null
      }
    },
    getIdCard () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
    pdfExport () {
      const reportTitle = this.$t('institute_manangement.ministry_welfare')
      ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.formData, this)
    }
  }
}
</script>
